module.exports = __webpack_public_path__ + "static/media/trionordestino-partitura.31907e4b.png";